export default __webpack_public_path__ + "static/media/wine-bottle.7b4ec375.svg";